export const namespaced = true;

const houseStates = ['altbau','neubau'];
const houseVariants = ['EFH','6-FH'];
const houseActions = {
    'altbau': ['IST_01','IST_02'],
    'neubau': ['EH55','mindest']
}

const stateData = {
    generalData: {},
    configuredData: {},
    calculationData: {},
    houseState: houseStates[0],
    houseVariant: houseVariants[0],
    houseAction: houseActions['altbau'][0],
    resultData: {},
}

export const state = () => (stateData);

export const getters = {
    getGeneralData: state => state.generalData,
    getConfiguredData: state => state.configuredData,
    getHouseState: state => state.houseState,
    getHouseStates: () => houseStates,
    getHouseVariant: state => state.houseVariant,
    getHouseVariants: () => houseVariants,
    getHouseAction: state => state.houseAction,
    getHouseActions: () => houseActions,
    getCalculationData: state => state.calculationData,
    getResultData: state => state.resultData,
}

export const mutations = {
    clearGeneralData(state) {
        state.generalData = {}
    },
    setGeneralData(state, generalData) {
        state.generalData = generalData;
    },
    setConfiguredData(state, configuredData) {
        state.configuredData = configuredData;
    },
    setHouseState(state, houseState) {
        state.houseState = houseState;
    },
    setHouseVariant(state, houseVariant) {
        state.houseVariant = houseVariant;
    },
    setHouseAction(state, houseAction) {
        state.houseAction = houseAction;
    },
    resetHouseData(state) {
        state.houseState = houseStates[0];
        state.houseVariant = houseVariants[0];
        state.houseAction = houseActions['altbau'][0];
    },
    setCalculationData(state, calculationData) {
        state.calculationData = calculationData;
    },
    setResultData(state, resultData) {
        state.resultData = resultData;
    }
};

export const actions = {
    clearGeneralData({commit}) {
        commit('clearGeneralData');
    },
    setGeneralData({commit}, generalData) {
        commit('setGeneralData', generalData);
    },
    setConfiguredData({commit}, configuredData) {
        commit('setConfiguredData', configuredData);
    },
    setHouseState({commit}, houseState) {
        commit('setHouseState',houseState);
    },
    setHouseVariant({commit}, houseVariant) {
        commit('setHouseVariant', houseVariant);
    },
    setHouseAction({commit}, houseAction) {
        commit('setHouseAction', houseAction);
    },
    resetHouseData({commit}) {
        commit('resetHouseData');
    },
    setCalculationData({commit},calculationData){
        commit('setCalculationData', calculationData);
    },
    setResultData({commit},resultData){
        commit('setResultData', resultData);
    }
};

